import { InputAdornment, TextField } from "@mui/material"
import { SearchOutlined } from "@mui-symbols-material/w300"
import React, { type ChangeEvent } from "react"

interface SearchInputProps {
  placeholder?: string
  defaultValue?: string
  value?: string
  onChange?: (e: ChangeEvent<HTMLInputElement>) => void
  className?: string
  "data-testid"?: string
}

const SearchInput: React.FC<SearchInputProps> = ({
  placeholder,
  defaultValue,
  value,
  onChange,
  className,
  "data-testid": testId = "search-input",
}) => {
  return (
    <TextField
      data-testid={testId}
      variant='outlined'
      placeholder={placeholder ?? "Search..."}
      size='small'
      defaultValue={defaultValue}
      value={value}
      onChange={onChange}
      className={className}
      slotProps={{
        input: {
          startAdornment: (
            <InputAdornment position='start'>
              <SearchOutlined className='text-gray-600' />
            </InputAdornment>
          ),
        },
      }}
    />
  )
}

export default SearchInput
